// ─────────────────────────────────────────────────────────────────────────────
// import
// ─────────────────────────────────────────────────────────────────────────────

import styled from 'styled-components';

// ─────────────────────────────────────────────────────────────────────────────
// ul + ol
// ─────────────────────────────────────────────────────────────────────────────

export const Ul = styled.ul`
  display: grid;

  list-style: none;

  & > li::marker {
    color: var(--color-primary);
  }
`;

export const Ol = styled.ol`
  display: grid;

  list-style: none;

  & > li::marker {
    color: var(--color-primary);
  }
`;

// ─────────────────────────────────────────────────────────────────────────────
// li
// ─────────────────────────────────────────────────────────────────────────────

export const Li = styled.li``;
